import React from 'react';
class Cart extends React.Component {
    render() { 
        return <div>ana elcart ya m3lm</div>;
    }
}
 
export default Cart;